<template>
	<el-dialog
		v-dialogDrag
		class="chat-selector-dialog im-dialog-shell im-dialog-shell--lg im-dialog-shell--mobile-center"
		:title="title"
		:visible.sync="show"
		width="780px"
		custom-class="chat-selector-panel"
		append-to-body
	>
		<div class="chat-selector" :class="{ 'has-selection': checkedItems.length > 0 }">
			<div class="left-box">
				<div class="panel-head">
					<el-input :placeholder="searchPlaceholder" v-model="searchText" size="small" clearable>
						<i class="el-icon-search el-input__icon" slot="suffix"> </i>
					</el-input>
					<tabs :items="tabItems" :current="tabIdx" @change="onTabChange"></tabs>
					<div class="select-tools">
							<el-checkbox
								v-model="allVisibleCheckedProxy"
								:indeterminate="isSelectAllIndeterminate"
								:disabled="sourceSelectableTargets.length === 0"
							>
								全选
							</el-checkbox>
						<div class="select-tools__actions">
							<div class="result-badge">{{ currentListCount }}</div>
							<el-button
								type="text"
								icon="el-icon-delete"
								class="icon-btn clear-btn"
								:disabled="checkedItems.length === 0"
								title="清空"
								@click="clearChecked"
							></el-button>
						</div>
					</div>
				</div>
					<virtual-scroller
						v-if="currentTab === 'recent' && showChats.length > 0"
						ref="recentScroller"
						key="recent"
						class="left-scroll-box"
						:items="showChats"
						:item-height="60"
						:item-key-getter="getRecentChatKey"
						@reach-bottom="onRecentListReachBottom"
					>
						<template v-slot="{ item }">
							<div class="chat-item" :class="{ checked: item.checked }" @click="onClickChatItem(item)">
								<head-image :url="item.headImage" :name="item.showName" :size="42"
									:variant="item.type == 'GROUP' ? 'group' : 'user'"></head-image>
								<div class="chat-info">
									<div class="chat-name">
										<div class="chat-name-text">{{ item.showName }}</div>
									</div>
									<div class="chat-content" v-html="$emo.transform($str.html2Escape(item.lastContent), 'emoji-small')"></div>
								</div>
								<el-checkbox v-model="item.checked" class="check-box" @click.native.stop="" @change="onChatChange(item)"></el-checkbox>
							</div>
						</template>
				</virtual-scroller>
				<empty-state
					v-else-if="currentTab === 'recent'"
					class="list-empty-state"
					icon="el-icon-search"
					:title="currentEmptyTitle"
					compact
				></empty-state>
					<virtual-scroller
						v-else-if="currentTab === 'friend' && showFriends.length > 0"
						ref="friendScroller"
						key="friend"
						class="left-scroll-box"
						:items="showFriends"
						:item-height="48"
						:item-key-getter="getFriendKey"
						@reach-bottom="onFriendListReachBottom"
					>
					<template v-slot="{ item }">
						<friend-item :menu="false" :friend="item" size="small" @click.native="onClickFriendItem(item)">
							<el-checkbox v-model="item.checked" class="check-box" @click.native.stop="" @change="onFriendChange(item)"></el-checkbox>
						</friend-item>
					</template>
				</virtual-scroller>
				<empty-state
					v-else-if="currentTab === 'friend'"
					class="list-empty-state"
					icon="el-icon-search"
					:title="currentEmptyTitle"
					compact
				></empty-state>
					<virtual-scroller
						v-else-if="currentTab === 'group' && showGroups.length > 0"
						ref="groupScroller"
						key="group"
						class="left-scroll-box"
						:items="showGroups"
						:item-height="48"
						:item-key-getter="getGroupKey"
						@reach-bottom="onGroupListReachBottom"
					>
					<template v-slot="{ item }">
						<group-item :group="item" :menu="false" size="small" @click.native="onClickGroupItem(item)">
							<el-checkbox v-model="item.checked" class="check-box" @click.native.stop="" @change="onGroupChange(item)"></el-checkbox>
						</group-item>
					</template>
				</virtual-scroller>
				<empty-state
					v-else-if="currentTab === 'group'"
					class="list-empty-state"
					icon="el-icon-search"
					:title="currentEmptyTitle"
					compact
				></empty-state>
				<friend-group-quick-select
					v-else-if="currentTab === 'friendGroup'"
					key="friendGroup"
					class="left-scroll-box"
					:groups="showFriendGroups"
					:checked-group-ids="checkedFriendGroupIds"
					:empty-title="currentEmptyTitle"
					@toggle-group="onToggleFriendGroup"
					@reach-bottom="onFriendGroupReachBottom"
				></friend-group-quick-select>
			</div>
				<div class="right-box">
					<div class="panel-head selection-head">
						<div class="panel-title compact-title">
							<i class="el-icon-position"></i>
							<span>已选</span>
							<span class="inline-count">{{ checkedItems.length }}</span>
						</div>
						<el-button v-if="checkedItems.length > 0" type="text" icon="el-icon-delete" class="icon-btn clear-btn"
							title="清空" @click="clearChecked()"></el-button>
					</div>
					<empty-state
						v-if="checkedItems.length === 0"
						class="right-scroll-box empty-state"
						icon="el-icon-position"
						:title="emptySelectionTitle"
						compact
					></empty-state>
							<virtual-scroller
								v-else
								class="right-scroll-box checked-scroll-box"
								:items="checkedItemsView"
								:item-height="54"
								:item-key-getter="getCheckedItemKey"
								@reach-bottom="onCheckedListReachBottom"
							>
						<template v-slot="{ item }">
						<div class="checked-item" @click="onRemoveItem(item)">
							<head-image :url="item.headImage" :name="item.showName" :size="34"
								:variant="item.type == 'GROUP' ? 'group' : 'user'"></head-image>
							<div class="checked-main">
							<div class="chat-name">
								<div class="chat-name-text">{{ item.showName }}</div>
							</div>
						</div>
							<div class="close" title="移除">
								<i class="el-icon-close"></i>
							</div>
						</div>
						</template>
					</virtual-scroller>
				</div>
		</div>
		<span slot="footer" class="dialog-footer selector-footer">
			<div class="footer-actions">
				<el-button @click="close()">取 消</el-button>
				<el-button type="primary" :disabled="checkedItems.length === 0" @click="ok()">{{ confirmButtonText }}</el-button>
			</div>
		</span>
	</el-dialog>
</template>
<script>
import HeadImage from '../common/HeadImage.vue';
import Tabs from '../common/Tabs.vue';
import VirtualScroller from '../common/VirtualScroller.vue';
import FriendItem from '../friend/FriendItem.vue';
import FriendGroupQuickSelect from '../friend/FriendGroupQuickSelect.vue';
import GroupItem from '../group/GroupItem.vue';
import {
	attachContactSearchText,
	CONTACT_SEARCH_TEXT_KEY,
	matchesPreparedContactKeyword
} from '../../utils/contactSearchMatcher';
import {
	buildFriendGroupOption,
	buildPrivateChatTargetsFromFriendGroup,
	countFriendGroupNewMembers,
	filterFriendGroupOptions
} from '../../utils/friendGroupSelection';
import { resolveGroupChatDisplayName, resolvePrivateDisplayName } from '../../utils/identityDisplay.js';

function resolveTargetKey(type, targetId) {
	return `${String(type || '')}:${targetId === undefined || targetId === null ? '' : String(targetId)}`;
}

const CHECKED_RESULT_PAGE_SIZE = 30;

export default {
	components: { VirtualScroller, HeadImage, Tabs, FriendItem, FriendGroupQuickSelect, GroupItem },
	name: "chatSelector",
	props: {
		title: {
			type: String,
			default: ""
		},
		enableFriendGroups: {
			type: Boolean,
			default: false
		}
	},
		data() {
			return {
				show: false,
				searchText: "",
				callback: null,
				tabIdx: 0,
				chats: [],
				friends: [],
				groups: [],
				checkedItems: [],
				checkedViewLimit: CHECKED_RESULT_PAGE_SIZE
			}
		},
			methods: {
				getRecentChatKey(chat) {
					if (!chat) {
						return '';
					}
					const key = resolveTargetKey(chat.type, chat.targetId);
					return key ? `recent:${key}` : '';
				},
				getFriendKey(friend) {
					if (!friend || !friend.id) {
						return '';
					}
					return `friend:${friend.id}`;
				},
				getGroupKey(group) {
					if (!group || !group.id) {
						return '';
					}
					return `group:${group.id}`;
				},
				getCheckedItemKey(item) {
					if (!item) {
						return '';
					}
					const key = resolveTargetKey(item.type, item.targetId);
					return key ? `checked:${key}` : '';
				},
				open(callback) {
				this.tabIdx = 0;
				this.searchText = "";
				this.show = true;
				this.callback = callback;
				this.checkedViewLimit = CHECKED_RESULT_PAGE_SIZE;
				this.initData();
			this.refreshFriendGroups().then(() => {
				this.initData({
					preserveChecked: true
				});
				this.syncCheckedState();
			}).catch((error) => {
				this.$message.error(this.extractErrorMessage(error) || '刷新好友分组失败');
			});
		},
		resolveSelectedPrivateFriendIdSet() {
			return new Set(this.checkedItems
				.filter((item) => item && item.type === 'PRIVATE' && item.targetId)
				.map((item) => String(item.targetId)));
		},
		async refreshFriendGroups() {
			if (!this.enableFriendGroups) {
				return Promise.resolve();
			}
			const groups = await this.friendGroupStore.loadGroups({
				limit: 30
			});
			return groups;
		},
			extractErrorMessage(error) {
				if (error && typeof error.message === 'string' && error.message) {
					return error.message;
				}
			if (error && typeof error.msg === 'string' && error.msg) {
				return error.msg;
			}
			if (error && error.response && error.response.data) {
				const responseData = error.response.data;
				if (typeof responseData === 'string' && responseData) {
					return responseData;
				}
				if (typeof responseData.message === 'string' && responseData.message) {
					return responseData.message;
				}
				}
				return '';
			},
			resolveRecentSessionHost() {
				let cursor = this.$parent;
				while (cursor) {
					if (cursor.recentSessionPage
						&& typeof cursor.loadMoreRecentChatsForSessionList === 'function') {
						return cursor;
					}
					cursor = cursor.$parent;
				}
				const root = this.$root;
				if (!root) {
					return null;
				}
				const stack = [root];
				while (stack.length > 0) {
					const vm = stack.pop();
					if (!vm) {
						continue;
					}
					if (vm.recentSessionPage
						&& typeof vm.loadMoreRecentChatsForSessionList === 'function') {
						return vm;
					}
					if (Array.isArray(vm.$children) && vm.$children.length > 0) {
						vm.$children.forEach((child) => {
							if (child) {
								stack.push(child);
							}
						});
					}
				}
				return null;
			},
			onRecentListReachBottom() {
				if (this.currentTab !== 'recent' || this.normalizedSearchText) {
					return;
				}
				const home = this.resolveRecentSessionHost();
				if (!home || !home.recentSessionPage || !home.recentSessionPage.more || !home.recentSessionPage.cursor) {
					return;
				}
			if (home.recentSessionBackgroundPromise) {
				return;
			}
			home.loadMoreRecentChatsForSessionList({
				maxPages: 1
			});
		},
		onFriendListReachBottom() {
			if (this.currentTab !== 'friend' || this.normalizedSearchText) {
				return;
			}
			if (this.friendStore.page.loading
				|| !this.friendStore.page.more
				|| !this.friendStore.page.cursor) {
				return;
			}
			this.friendStore.loadMoreFriendsFromCursor({
				maxPages: 1
			}).then(() => {
				this.initData({
					preserveChecked: true
				});
				this.syncCheckedState();
			}).catch((error) => {
				console.warn('ChatSelector 滚动续拉好友分页失败', error);
			});
		},
		onGroupListReachBottom() {
			if (this.currentTab !== 'group' || this.normalizedSearchText) {
				return;
			}
			if (this.groupStore.list.page.loading
				|| !this.groupStore.list.page.more
				|| !this.groupStore.list.page.cursor) {
				return;
			}
			this.groupStore.loadMoreGroupsFromCursor({
				maxPages: 1
			}).then(() => {
				this.initData({
					preserveChecked: true
				});
				this.syncCheckedState();
			}).catch((error) => {
				console.warn('ChatSelector 滚动续拉群分页失败', error);
			});
		},
		initData(options = {}) {
			const preserveChecked = options.preserveChecked === true;
			const checkedSnapshot = preserveChecked ? this.checkedItems.slice() : [];
			if (!preserveChecked) {
				this.checkedItems = [];
			}
			this.chats = [];
			this.friends = [];
			this.groups = [];
			this.chatStore.chats.forEach(chat => {
				if (chat.type == 'PRIVATE' && this.friendStore.isFriend(chat.targetId)) {
					const friend = this.friendStore.findFriend(chat.targetId) || {};
					const showName = resolvePrivateDisplayName(friend) || chat.showName || '';
					if (!showName) {
						return;
					}
					this.chats.push(attachContactSearchText({
						type: chat.type,
						targetId: chat.targetId,
						headImage: friend.headImage || chat.headImage,
						showName,
						lastContent: chat.lastContent,
						userName: chat.userName || friend.userName || '',
						checked: false
					}, ['lastContent']))
				}
				if (chat.type == 'GROUP' && this.groupStore.isGroup(chat.targetId)) {
					this.chats.push(attachContactSearchText({
						type: chat.type,
						targetId: chat.targetId,
						headImage: chat.headImage,
						showName: chat.showName,
						lastContent: chat.lastContent,
						userName: chat.userName || '',
						checked: false
					}, ['lastContent']))
				}
			})
			this.friendStore.friends.forEach(friend => {
				if (!friend.deleted) {
					const showNickName = resolvePrivateDisplayName(friend);
					if (!showNickName) {
						return;
					}
					this.friends.push(attachContactSearchText({
						id: friend.id,
						headImage: friend.headImage,
						showNickName,
						userName: friend.userName,
						checked: false
					}))
				}
			})
			this.groupStore.groups.forEach(group => {
				if (!group.quit) {
					this.groups.push(attachContactSearchText({
						id: group.id,
						headImage: group.headImage,
						headImageThumb: group.headImageThumb,
						showGroupName: resolveGroupChatDisplayName(group) || group.showGroupName || group.name,
						checked: false
					}))
				}
			})
			if (preserveChecked) {
				this.checkedItems = checkedSnapshot;
			}
		},
			close() {
				this.show = false;
				this.checkedViewLimit = CHECKED_RESULT_PAGE_SIZE;
			},
		ok() {
			if (this.checkedItems.length === 0) {
				return;
			}
			this.close();
			this.callback(this.checkedItems);
		},
		onTabChange(idx) {
			this.tabIdx = idx;
			this.syncCheckedState();
			if (this.currentTab === 'friendGroup'
				&& this.friendGroupStore.groups.length === 0
				&& !this.friendGroupStore.page.loading) {
				this.refreshFriendGroups().catch((error) => {
					console.warn('ChatSelector 切换好友分组后刷新失败', error);
				});
			}
		},
		getTargetKey(item) {
			return resolveTargetKey(item && item.type, item && item.targetId);
		},
		findCheckedIndex(type, targetId) {
			const index = this.checkedTargetIndexMap.get(resolveTargetKey(type, targetId));
			return index === undefined ? -1 : index;
		},
		isTargetChecked(type, targetId) {
			return this.findCheckedIndex(type, targetId) >= 0;
		},
		toCheckedChatItem(chatItem) {
			return {
				type: chatItem.type,
				targetId: chatItem.targetId,
				headImage: chatItem.headImage,
				showName: chatItem.showName,
				userName: chatItem.userName || ''
			};
		},
		toCheckedFriendItem(friend) {
			return {
				targetId: friend.id,
				type: 'PRIVATE',
				showName: friend.showNickName || friend.nickName || friend.userName,
				headImage: friend.headImage,
				userName: friend.userName || ''
			};
		},
			toCheckedGroupItem(group) {
				return {
					targetId: group.id,
					type: 'GROUP',
					showName: group.showGroupName || group.name || '群聊',
					headImage: group.headImageThumb || group.headImage
				};
			},
			buildTargetsForTab(tab, { ignoreSearch = false } = {}) {
				const keyword = ignoreSearch ? '' : this.normalizedSearchText;
				if (tab === 'recent') {
					return this.chats
						.filter((chat) => {
							if (!chat || !chat.type || !chat.targetId || !chat.showName) {
								return false;
							}
							return matchesPreparedContactKeyword(chat[CONTACT_SEARCH_TEXT_KEY], keyword);
						})
						.map((chat) => this.toCheckedChatItem(chat));
				}
				if (tab === 'friend') {
					return this.friends
						.filter((friend) => {
							if (!friend) {
								return false;
							}
							return matchesPreparedContactKeyword(friend[CONTACT_SEARCH_TEXT_KEY], keyword);
						})
						.map((friend) => this.toCheckedFriendItem(friend));
				}
				if (tab === 'group') {
					return this.groups
						.filter((group) => {
							if (!group) {
								return false;
							}
							return matchesPreparedContactKeyword(group[CONTACT_SEARCH_TEXT_KEY], keyword);
						})
						.map((group) => this.toCheckedGroupItem(group));
				}
				const friendGroupOptions = filterFriendGroupOptions(
					this.friendGroupStore.groups.map((group) => buildFriendGroupOption(group, this.friendStore, this.friendGroupStore)),
					keyword
				);
				const targets = [];
				const keySet = new Set();
				friendGroupOptions.forEach((group) => {
					buildPrivateChatTargetsFromFriendGroup(group, this.friendStore, this.friendGroupStore).forEach((target) => {
						const key = this.getTargetKey(target);
						if (keySet.has(key)) {
							return;
						}
						keySet.add(key);
						targets.push(target);
					});
				});
				return targets;
			},
				setTargetChecked(target, checked) {
				if (!target || !target.type || !target.targetId) {
					return;
				}
				const idx = this.findCheckedIndex(target.type, target.targetId);
				if (checked) {
					if (idx < 0) {
						this.checkedItems.push(target);
						if (this.checkedItems.length <= this.checkedViewLimit + 1) {
							this.checkedViewLimit = this.checkedItems.length;
						}
					}
					this.syncCheckedState();
					return;
				}
			if (idx >= 0) {
				this.checkedItems.splice(idx, 1);
			}
			this.syncCheckedState();
		},
		onClickChatItem(chatItem) {
			this.setTargetChecked(this.toCheckedChatItem(chatItem), !this.isTargetChecked(chatItem.type, chatItem.targetId));
		},
		onChatChange(chatItem) {
			this.setTargetChecked(this.toCheckedChatItem(chatItem), chatItem.checked);
		},
		onClickFriendItem(friend) {
			this.setTargetChecked(this.toCheckedFriendItem(friend), !this.isTargetChecked('PRIVATE', friend.id));
		},
		onFriendChange(friend) {
			this.setTargetChecked(this.toCheckedFriendItem(friend), friend.checked);
		},
		onClickGroupItem(group) {
			this.setTargetChecked(this.toCheckedGroupItem(group), !this.isTargetChecked('GROUP', group.id));
		},
		onGroupChange(group) {
			this.setTargetChecked(this.toCheckedGroupItem(group), group.checked);
		},
			async onSelectFriendGroup(group) {
				try {
					await this.friendGroupStore.ensureGroupFriendsFullyLoaded(group.id, {
						limit: 30,
						includeOnline: false
					});
				this.initData({
					preserveChecked: true
				});
				this.syncCheckedState();
			} catch (error) {
				console.warn('ChatSelector 加载好友分组成员失败', error);
			}
			const selectedPrivateFriendIdSet = this.resolveSelectedPrivateFriendIdSet();
			const targets = buildPrivateChatTargetsFromFriendGroup(group, this.friendStore, this.friendGroupStore)
				.filter((target) => !selectedPrivateFriendIdSet.has(String(target.targetId)));
			const checkedKeySet = new Set(this.checkedTargetKeySet);
			let addedCount = 0;
			targets.forEach((target) => {
				const key = this.getTargetKey(target);
				if (checkedKeySet.has(key)) {
					return;
				}
				this.checkedItems.push(target);
				checkedKeySet.add(key);
				addedCount += 1;
			});
			if (addedCount === 0) {
				this.$message.info('该好友分组成员已全部加入当前选择');
				}
				this.syncCheckedState();
			},
			async onDeselectFriendGroup(group) {
				try {
					await this.friendGroupStore.ensureGroupFriendsFullyLoaded(group.id, {
						limit: 30,
						includeOnline: false
					});
					this.initData({
						preserveChecked: true
					});
					this.syncCheckedState();
				} catch (error) {
					console.warn('ChatSelector 加载好友分组成员失败', error);
				}
				const removeKeySet = new Set(
					buildPrivateChatTargetsFromFriendGroup(group, this.friendStore, this.friendGroupStore)
						.map((item) => this.getTargetKey(item))
				);
				if (removeKeySet.size === 0) {
					return;
				}
				this.checkedItems = this.checkedItems.filter((item) => !removeKeySet.has(this.getTargetKey(item)));
				this.syncCheckedState();
			},
			onToggleFriendGroup(payload) {
				const group = payload && payload.group ? payload.group : null;
				const checked = payload && typeof payload.checked === 'boolean' ? payload.checked : false;
				if (!group) {
					return;
				}
				if (checked) {
					this.onSelectFriendGroup(group);
					return;
				}
				this.onDeselectFriendGroup(group);
			},
		onRemoveItem(chatItem) {
			this.setTargetChecked(chatItem, false);
		},
			clearChecked() {
				this.checkedItems = [];
				this.checkedViewLimit = CHECKED_RESULT_PAGE_SIZE;
				this.syncCheckedState();
			},
		setSourceChecked(checked) {
				const sourceTargets = this.sourceSelectableTargets;
				if (checked) {
					const checkedKeySet = new Set(this.checkedItems.map((item) => this.getTargetKey(item)));
					sourceTargets.forEach((target) => {
						const key = this.getTargetKey(target);
						if (!checkedKeySet.has(key)) {
							this.checkedItems.push(target);
							checkedKeySet.add(key);
						}
					});
					this.syncCheckedState();
					return;
				}
				const sourceKeySet = new Set(sourceTargets.map((item) => this.getTargetKey(item)));
				this.checkedItems = this.checkedItems.filter((item) => !sourceKeySet.has(this.getTargetKey(item)));
				this.syncCheckedState();
			},
			async ensureCurrentTabSourceFullyLoaded() {
				if (this.currentTab === 'recent') {
					const home = this.resolveRecentSessionHost();
					if (home) {
						if (typeof home.ensureRecentChatsFullyLoaded === 'function') {
							await home.ensureRecentChatsFullyLoaded({
								limit: 30
							});
						} else {
							while (home.recentSessionPage
								&& home.recentSessionPage.more
								&& home.recentSessionPage.cursor) {
								await home.loadMoreRecentChatsForSessionList({
									maxPages: 1
								});
							}
						}
					}
				}
			if (this.currentTab === 'friend') {
				await this.friendStore.ensureFriendListFullyLoaded({
					limit: 30
				});
			}
			if (this.currentTab === 'group') {
				await this.groupStore.ensureGroupListFullyLoaded({
					limit: 30
				});
			}
			if (this.currentTab === 'friendGroup') {
				await this.friendGroupStore.ensureGroupListFullyLoaded({
					limit: 30
				});
				const groupIds = this.showFriendGroups
					.map((group) => group && group.id)
					.filter(Boolean);
				for (const groupId of groupIds) {
					await this.friendGroupStore.ensureGroupFriendsFullyLoaded(groupId, {
						limit: 30,
						includeOnline: false
					});
				}
			}
		},
			onFriendGroupReachBottom() {
				if (this.currentTab !== 'friendGroup' || this.normalizedSearchText) {
					return;
				}
			if (this.friendGroupStore.page.loading
				|| !this.friendGroupStore.page.more
				|| !this.friendGroupStore.page.cursor) {
				return;
			}
			this.friendGroupStore.loadMoreGroupsFromCursor({
				limit: 30,
				maxPages: 1
			}).then(() => {
				this.initData({
					preserveChecked: true
				});
				this.syncCheckedState();
				}).catch((error) => {
					console.warn('ChatSelector 滚动续拉好友分组失败', error);
				});
			},
			async ensureCheckedWindowHydrated() {
				if (!this.show) {
					return;
				}
					const targetSize = Math.max(CHECKED_RESULT_PAGE_SIZE, Math.floor(Number(this.checkedViewLimit) || 0));
					while (this.show && this.checkedItems.length < targetSize) {
						const beforeLength = this.checkedItems.length;
						if (this.currentTab === 'recent') {
							const home = this.resolveRecentSessionHost();
							if (!home
								|| home.recentSessionBackgroundPromise
								|| !home.recentSessionPage
							|| !home.recentSessionPage.more
							|| !home.recentSessionPage.cursor) {
							break;
						}
						await home.loadMoreRecentChatsForSessionList({
							maxPages: 1
						});
						await this.$nextTick();
						if (this.checkedItems.length <= beforeLength) {
							break;
						}
						continue;
					}
					if (this.currentTab === 'friend') {
						if (this.friendStore.page.loading
							|| !this.friendStore.page.more
							|| !this.friendStore.page.cursor) {
							break;
						}
						await this.friendStore.loadMoreFriendsFromCursor({
							maxPages: 1
						});
						this.initData({
							preserveChecked: true
						});
						this.syncCheckedState();
						await this.$nextTick();
						if (this.checkedItems.length <= beforeLength) {
							break;
						}
						continue;
					}
					if (this.currentTab === 'group') {
						if (this.groupStore.list.page.loading
							|| !this.groupStore.list.page.more
							|| !this.groupStore.list.page.cursor) {
							break;
						}
						await this.groupStore.loadMoreGroupsFromCursor({
							maxPages: 1
						});
						this.initData({
							preserveChecked: true
						});
						this.syncCheckedState();
						await this.$nextTick();
						if (this.checkedItems.length <= beforeLength) {
							break;
						}
						continue;
					}
					if (this.friendGroupStore.page.loading
						|| !this.friendGroupStore.page.more
						|| !this.friendGroupStore.page.cursor) {
						break;
					}
					await this.friendGroupStore.loadMoreGroupsFromCursor({
						limit: 30,
						maxPages: 1
					});
					this.initData({
						preserveChecked: true
					});
					this.syncCheckedState();
					await this.$nextTick();
					if (this.checkedItems.length <= beforeLength) {
						break;
					}
				}
			},
			async onCheckedListReachBottom() {
				const nextLimit = Math.max(CHECKED_RESULT_PAGE_SIZE, Math.floor(Number(this.checkedViewLimit) || 0)) + CHECKED_RESULT_PAGE_SIZE;
				const maxCount = Math.max(this.checkedItems.length, this.currentListCount);
				this.checkedViewLimit = Math.min(maxCount, nextLimit);
				await this.ensureCheckedWindowHydrated();
			},
			async onToggleGlobalSelectAll(checked) {
				if (checked) {
					try {
						await this.ensureCurrentTabSourceFullyLoaded();
						this.initData({
							preserveChecked: true
						});
					} catch (error) {
						console.warn('ChatSelector 全量加载源数据失败', error);
					}
				}
				this.setSourceChecked(checked);
				if (checked) {
					this.checkedViewLimit = CHECKED_RESULT_PAGE_SIZE;
					await this.ensureCheckedWindowHydrated();
				}
			},
		syncCheckedState() {
			const checkedKeySet = this.checkedTargetKeySet;
			this.chats.forEach(chat => {
				chat.checked = checkedKeySet.has(resolveTargetKey(chat && chat.type, chat && chat.targetId));
			})
			this.friends.forEach(friend => {
				friend.checked = checkedKeySet.has(resolveTargetKey('PRIVATE', friend && friend.id));
			})
			this.groups.forEach(group => {
				group.checked = checkedKeySet.has(resolveTargetKey('GROUP', group && group.id));
			})
		}
	},
	computed: {
		tabItems() {
			const items = ['最近聊天', '好友', '群聊'];
			if (this.enableFriendGroups) {
				items.push('好友分组');
			}
			return items;
		},
		currentTab() {
			if (this.enableFriendGroups && this.tabIdx === 3) {
				return 'friendGroup';
			}
			if (this.tabIdx === 1) {
				return 'friend';
			}
			if (this.tabIdx === 2) {
				return 'group';
			}
			return 'recent';
		},
		normalizedSearchText() {
			return String(this.searchText || '').trim().toLowerCase();
		},
		checkedTargetKeySet() {
			return new Set(this.checkedItems.map((item) => this.getTargetKey(item)));
		},
		checkedTargetIndexMap() {
			const indexMap = new Map();
			this.checkedItems.forEach((item, index) => {
				indexMap.set(this.getTargetKey(item), index);
			});
			return indexMap;
		},
			selectorState() {
				const checkedKeySet = this.checkedTargetKeySet;
				const keyword = this.normalizedSearchText;
				const showChats = [];
				const showFriends = [];
				const showGroups = [];
				this.chats.forEach((chat) => {
					if (!chat || !chat.type || !chat.targetId || !chat.showName) {
						return;
					}
					if (matchesPreparedContactKeyword(chat[CONTACT_SEARCH_TEXT_KEY], keyword)) {
						showChats.push(chat);
					}
				});
				this.friends.forEach((friend) => {
					if (!friend) {
						return;
					}
					if (matchesPreparedContactKeyword(friend[CONTACT_SEARCH_TEXT_KEY], keyword)) {
						showFriends.push(friend);
					}
				});
				this.groups.forEach((group) => {
					if (!group) {
						return;
					}
					if (matchesPreparedContactKeyword(group[CONTACT_SEARCH_TEXT_KEY], keyword)) {
						showGroups.push(group);
					}
				});
				const selectedPrivateFriendIds = [];
				this.checkedItems.forEach((item) => {
					if (item && item.type === 'PRIVATE') {
						selectedPrivateFriendIds.push(item.targetId);
					}
				});
				const showFriendGroups = filterFriendGroupOptions(
					this.friendGroupStore.groups.map((group) => buildFriendGroupOption(group, this.friendStore, this.friendGroupStore)),
					keyword
				);
			const visibleSelectableTargets = this.buildTargetsForTab(this.currentTab, {
				ignoreSearch: false
			});
			const sourceSelectableTargets = this.buildTargetsForTab(this.currentTab, {
				ignoreSearch: true
			});
			let visibleCheckedCount = 0;
			visibleSelectableTargets.forEach((target) => {
				if (checkedKeySet.has(this.getTargetKey(target))) {
					visibleCheckedCount += 1;
				}
			});
			let sourceCheckedCount = 0;
			sourceSelectableTargets.forEach((target) => {
				if (checkedKeySet.has(this.getTargetKey(target))) {
					sourceCheckedCount += 1;
				}
			});
			return {
				selectedPrivateFriendIds,
				showChats,
				showFriends,
				showGroups,
				showFriendGroups,
				visibleSelectableTargets,
				visibleCheckedCount,
				sourceSelectableTargets,
				sourceCheckedCount
			};
		},
		showChats() {
			return this.selectorState.showChats;
		},
		showFriends() {
			return this.selectorState.showFriends;
		},
		showGroups() {
			return this.selectorState.showGroups;
		},
		showFriendGroups() {
			return this.selectorState.showFriendGroups;
		},
		checkedFriendGroupIds() {
			const selectedPrivateFriendIdSet = new Set(this.selectedPrivateFriendIds.map((id) => String(id)));
			return this.friendGroupStore.groups
				.map((group) => buildFriendGroupOption(group, this.friendStore, this.friendGroupStore))
				.filter((group) => countFriendGroupNewMembers(group, selectedPrivateFriendIdSet) <= 0)
				.map((group) => group.id)
				.filter(Boolean);
		},
		selectedPrivateFriendIds() {
			return this.selectorState.selectedPrivateFriendIds;
		},
		visibleSelectableTargets() {
			return this.selectorState.visibleSelectableTargets;
		},
		sourceSelectableTargets() {
			return this.selectorState.sourceSelectableTargets;
		},
			visibleCheckedCount() {
				return this.selectorState.visibleCheckedCount;
			},
		sourceCheckedCount() {
			return this.selectorState.sourceCheckedCount;
		},
			checkedItemsView() {
				const limit = Math.max(CHECKED_RESULT_PAGE_SIZE, Math.floor(Number(this.checkedViewLimit) || 0));
				if (this.checkedItems.length <= limit) {
					return this.checkedItems;
				}
				return this.checkedItems.slice(0, limit);
			},
			isAllVisibleChecked() {
				return this.sourceSelectableTargets.length > 0 && this.sourceCheckedCount === this.sourceSelectableTargets.length;
			},
		isSelectAllIndeterminate() {
			return this.sourceCheckedCount > 0 && this.sourceCheckedCount < this.sourceSelectableTargets.length;
		},
			allVisibleCheckedProxy: {
				get() {
					return this.isAllVisibleChecked;
				},
				set(checked) {
					this.onToggleGlobalSelectAll(checked);
				}
			},
			currentListCount() {
				return this.sourceTotalByTab;
			},
			searchPlaceholder() {
				if (this.currentTab === 'friend') {
					return '搜索好友昵称或完整账号';
				}
				if (this.currentTab === 'group') {
					return '搜索群聊名称';
				}
				if (this.currentTab === 'friendGroup') {
					return '搜索好友分组名称';
				}
				return '搜索最近会话、好友或群聊';
			},
			confirmButtonText() {
				return '发送';
			},
			emptySelectionTitle() {
				return '请选择转发目标';
			},
			currentEmptyTitle() {
				if (this.normalizedSearchText) {
					return '无结果';
				}
				if (this.currentTab === 'friendGroup') {
					return '暂无可选好友分组';
				}
				return `暂无可选${this.tabItems[this.tabIdx] || '会话'}`;
			},
		sourceTotalByTab() {
			if (this.currentTab === 'recent') {
				const home = this.resolveRecentSessionHost();
				const total = Number(home && home.recentSessionPage && home.recentSessionPage.total);
				if (Number.isFinite(total) && total > 0) {
					return Math.floor(total);
				}
				return this.sourceSelectableTargets.length;
			}
			if (this.currentTab === 'friend') {
				if (this.normalizedSearchText) {
					return this.visibleSelectableTargets.length;
				}
				return Math.max(0, Math.floor(Number(this.friendStore.page.total || 0)));
			}
			if (this.currentTab === 'group') {
				if (this.normalizedSearchText) {
					return this.visibleSelectableTargets.length;
				}
				return Math.max(0, Math.floor(Number(this.groupStore.list.page.total || 0)));
			}
			return this.sourceSelectableTargets.length;
		},
	}
}
</script>

<style lang="scss">
.chat-selector-panel {
	width: min(760px, calc(100vw - 24px)) !important;
	max-height: calc(100vh - 24px) !important;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	border-radius: 6px;
	overflow: hidden;
	border: 1px solid var(--im-surface-panel-border);
	background: var(--im-chat-bg);
	box-shadow: none;
}

.chat-selector-panel .el-dialog__header {
	padding: 14px 18px 0;
	background: var(--im-chat-bg);
}

.chat-selector-panel .el-dialog__title {
	font-size: 16px;
	font-weight: 600;
	color: var(--im-text-color);
}

.chat-selector-panel .el-dialog__headerbtn {
	top: 16px;
	right: 16px;
}

.chat-selector-panel .el-dialog__body {
	flex: 1;
	min-height: 0;
	overflow: hidden;
	padding: 10px 16px 12px;
	background: var(--im-chat-bg);
}

.chat-selector-panel .el-dialog__footer {
	flex-shrink: 0;
	padding: 10px 16px 14px;
	border-top: 1px solid var(--im-surface-panel-border);
	background: var(--im-chat-bg);
}

.chat-selector {
	display: grid;
	grid-template-columns: minmax(0, 1fr) minmax(188px, 210px);
	align-items: stretch;
	gap: 8px;
	height: min(416px, calc(100vh - 172px));
	min-height: 0;
	max-height: 100%;

	.panel-head {
		display: flex;
		flex-direction: column;
		gap: 6px;
		padding: 8px 10px 7px;
		border-bottom: 1px solid var(--im-surface-panel-border);
	}

	.panel-title {
		font-size: 14px;
		font-weight: 600;
		color: var(--im-text-color);
		text-align: left;
	}

	.compact-title {
		display: inline-flex;
		align-items: center;
		gap: 8px;
	}

	.inline-count {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		min-width: 22px;
		height: 22px;
		padding: 0 6px;
		border-radius: 4px;
		background: rgba(var(--im-primary-rgb), 0.08);
		color: var(--im-color-primary);
		font-size: 12px;
		font-weight: 600;
	}

	.result-badge {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		min-width: 24px;
		height: 24px;
		padding: 0 7px;
		border-radius: 4px;
		background: rgba(var(--im-primary-rgb), 0.08);
		color: var(--im-color-primary);
		font-size: 12px;
		font-weight: 600;
	}

	.left-box,
	.right-box {
		display: flex;
		flex-direction: column;
		min-width: 0;
		border: 1px solid var(--im-surface-panel-border);
		border-radius: 6px;
		overflow: hidden;
		background: transparent;
	}

	.left-scroll-box,
	.right-scroll-box {
		flex: 1;
		height: 100%;
		min-height: 0;
	}

	.select-tools {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 8px;
		min-height: 32px;
	}

	.select-tools__actions {
		display: inline-flex;
		align-items: center;
		gap: 6px;
		margin-left: auto;
	}

	.list-empty-state {
		flex: 1;
		margin: 8px;
	}

	.left-box {
		.chat-item {
			display: flex;
			align-items: center;
			gap: 8px;
			box-sizing: border-box;
			min-height: 52px;
			margin: 2px 6px;
			padding: 5px 8px;
			border-radius: 6px;
			border: 1px solid transparent;
			cursor: pointer;
			transition: background-color 0.2s ease;

			.chat-info {
				flex: 1;
				display: flex;
				flex-direction: column;
				gap: 4px;
				min-width: 0;
				text-align: left;
				overflow: hidden;
			}

			.chat-name {
				display: flex;
				align-items: center;
				gap: 6px;
				min-width: 0;

				.chat-name-text {
					font-size: var(--im-font-size);
					line-height: 1.2;
					font-weight: 600;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}
			}

			.chat-content {
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				font-size: var(--im-font-size-small);
				color: var(--im-text-color-light);
				line-height: 1.2;
			}

			.check-box {
				margin-left: auto;
				padding-left: 8px;
			}

			&:hover {
				background: var(--im-control-soft-bg-hover);
			}

			&.checked {
				background: rgba(var(--im-primary-rgb), 0.06);
			}
		}
	}

	.right-box {
		.selection-head {
			flex-direction: row;
			align-items: center;
			justify-content: space-between;
		}

		.clear-btn {
			color: var(--im-icon-color);

			&:hover {
				color: var(--im-icon-hover-color);
			}
		}

		.icon-btn {
			padding: 4px;
		}

		.checked-scroll-box {
			.virtual-content {
				padding: 5px;
				box-sizing: border-box;
			}
		}

		.empty-state {
			height: 100%;
			margin: 0;
		}

		.checked-item {
			display: flex;
			align-items: center;
			gap: 8px;
			padding: 7px 8px;
			margin-bottom: 4px;
			border-radius: 6px;
			border: 1px solid transparent;
			background: var(--im-control-soft-bg);
			cursor: pointer;
			transition: background-color 0.2s ease, border-color 0.2s ease;

			.checked-main {
				flex: 1;
				min-width: 0;
			}

			.chat-name {
				display: flex;
				align-items: center;
				gap: 6px;
				min-width: 0;

				.chat-name-text {
					font-size: var(--im-font-size);
					font-weight: 600;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}
			}

			.close {
				display: inline-flex;
				align-items: center;
				justify-content: center;
				width: 18px;
				height: 18px;
				border-radius: 0;
				color: var(--im-icon-color);
				transition: color 0.2s ease;
				flex-shrink: 0;
			}

			&:hover {
				background: rgba(var(--im-primary-rgb), 0.04);

				.close {
					color: var(--im-icon-hover-color);
				}
			}
		}
	}
}

.selector-footer {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 12px;
	width: 100%;

	.footer-actions {
		display: inline-flex;
		align-items: center;
		gap: 8px;
	}
}

@media (max-width: 960px) {
	.chat-selector-panel {
		max-height: calc(100vh - 16px) !important;
	}

	.chat-selector-panel .el-dialog__header {
		padding: 14px 16px 0;
	}

	.chat-selector-panel .el-dialog__body {
		padding: 10px 16px 12px;
	}

	.chat-selector-panel .el-dialog__footer {
		padding: 10px 16px 14px;
	}

	.chat-selector {
		grid-template-columns: 1fr;
		grid-template-rows: minmax(0, 1fr) auto;
		height: calc(100vh - 184px);

		.left-scroll-box,
		.list-empty-state {
			min-height: 200px;
		}

		.right-box {
			min-height: 108px;
		}

		.right-scroll-box {
			min-height: 78px;
			max-height: 102px;
		}

		.right-scroll-box.virtual-scroller {
			overflow-x: auto;
			overflow-y: hidden;
		}

		.right-scroll-box .virtual-content {
			display: flex;
			gap: 8px;
			min-width: 100%;
			padding: 0 2px;
		}

		.right-box {
			.checked-item {
				flex: 0 0 172px;
				margin-bottom: 0;
				border-radius: 8px;
			}

			.empty-state {
				width: 100%;
				padding: 18px 10px;
			}
		}
	}

	.selector-footer {
		flex-direction: column;
		align-items: stretch;

		.footer-actions {
			justify-content: flex-end;
		}
	}
}

@media (max-width: 640px) {
	.chat-selector-dialog {
		display: flex;
		align-items: center;
		padding: 12px;
		overflow: hidden;
	}

	.chat-selector-panel {
		width: calc(100vw - 24px) !important;
		max-height: min(760px, calc(100vh - 48px)) !important;
		margin: 0 auto !important;
		border-radius: 6px;
	}

	.chat-selector-panel .el-dialog__header {
		padding: 12px 16px 0;
	}

	.chat-selector-panel .el-dialog__body {
		padding: 8px 12px 12px;
	}

	.chat-selector-panel .el-dialog__footer {
		padding: 8px 12px calc(12px + env(safe-area-inset-bottom));
	}

	.chat-selector-panel .el-dialog__headerbtn {
		top: 14px;
		right: 14px;
	}

	.chat-selector {
		gap: 10px;
		height: min(640px, calc(100vh - 210px));

		.panel-head {
			padding: 8px 10px;
		}

		.left-box,
		.right-box {
			border-radius: 6px;
		}

		.right-box {
			min-height: 102px;

			.checked-item {
				flex-basis: 156px;
				padding: 6px 8px;
			}

			.close {
				width: 20px;
				height: 20px;
			}
		}

		.right-scroll-box {
			min-height: 72px;
			max-height: 88px;
		}
	}

	.selector-footer .footer-actions {
		display: grid;
		grid-template-columns: 92px minmax(0, 1fr);
		width: 100%;
	}
}
</style>
